import {useRouter} from "vue-router";
import {useUserStore} from "@/stores/user";

export const useLogout = () => {

  const userStore = useUserStore()
  const router = useRouter();

  function logout() {
    const secondUser = userStore.hasSecondUser
    userStore.action_terminateSession({credential: userStore.getCredential})
    userStore.resetUser()
    if (secondUser) {
      window.location.reload()
    } else {
      router.push({name: 'Login'})
    }
  }

  return {logout}
}
